import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {catchError, throwError} from 'rxjs';
import {ApiError} from '@core/types';
import {ErrorService} from '@core/services';
import {HTTP_STATUS} from '@core/utils';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorService);
  const router = inject(Router);
  const SKIP_ERROR_HEADER = 'X-Skip-Error';

  if (req.headers.has(SKIP_ERROR_HEADER)) {
    const cleanHeaders = req.headers.delete(SKIP_ERROR_HEADER);
    return next(req.clone({headers: cleanHeaders})).pipe(
      catchError((error: any) => throwError(() => error))
    );
  }

  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse) {
        const status = error.status;
        const payload = error.error || {};
        const apiError: ApiError = {
          message: payload['hydra:description'] || payload.message || `Error ${status}`,
          details: payload.violations || payload.details || payload
        };

        if (status === HTTP_STATUS.UNAUTHORIZED) {
          errorService.setError({
            message: 'Sesion expirada. Por favor vuelve a iniciar sesion.',
            details: apiError.details
          }, status);
          const requestUrl = (req.url || '').toLowerCase();
          if (requestUrl.includes('/api/login')) {
            return throwError(() => error);
          }

          const currentUrl = router.url || '';
          const clientMatch = currentUrl.match(/\/compliants\/client\/([^\/]+)/i);
          if (clientMatch && clientMatch[1]) {
            router.navigate(['/compliants/client', clientMatch[1], 'login']);
          } else {
            router.navigate(['/login']);
          }
        } else if (status === HTTP_STATUS.FORBIDDEN ||
          status === HTTP_STATUS.NOT_FOUND ||
          status === HTTP_STATUS.INTERNAL_SERVER_ERROR) {
          errorService.setError(apiError, status);
          if (status === HTTP_STATUS.FORBIDDEN) {
            router.navigate(['/multi-user']);
          } else {
            router.navigate(['/error']);
          }
        } else if (status === HTTP_STATUS.UNPROCESSABLE_ENTITY || status === HTTP_STATUS.BAD_REQUEST) {
          errorService.setError(apiError, status);
        }
      }

      return throwError(() => error);
    })
  );
};
